import { render, staticRenderFns } from "./ResetearCamposImport.vue?vue&type=template&id=67d0ede4"
import script from "./ResetearCamposImport.vue?vue&type=script&lang=js"
export * from "./ResetearCamposImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports